import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const LugarJuegos = () => {

    const { setPromptData, promptData } = useActividadesContext();

    const handleLugarJuegosChange = (event: any) => {
        const { value } = event.target;
        setPromptData((prevData: any) => ({
            ...prevData,
            lugar: value
        }));
    };


    return (
        <Grid xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} >
                Lugar donde se va a jugar *
            </Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Detalla las características del lugar o espacio donde se realizara la actividad.</FormLabel>
            <TextField
                required
                id="contexto"
                placeholder='Ejemplo: Libreria de la escuela.'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={promptData.lugar}
                onChange={handleLugarJuegosChange}
                InputProps={{
                    sx: {
                        borderRadius: 2,
                        mt: 1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default LugarJuegos;




